<template>
	<div class="sp-template">
		<div class="h-title">车辆管理</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
					<el-form-item>
						<el-input v-model="conditions.search" placeholder="请输入车型或车牌号" clearable @change="searchVehicle()"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button v-if="in_configs(70404)" type="primary" @click="searchVehicle()">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button v-if="in_configs(70401)" size="small" @click="dialogFormVisible = true">添加车辆</el-button>
        </div>
      </div>
			<el-table ref="multipleTable" :data="vehicleData" stripe border style="width: 100%">
				<el-table-column prop="model" label="车型"></el-table-column>
				<el-table-column prop="licensePlate" label="车牌"></el-table-column>
				<el-table-column prop="vehicleType" label="车辆类型"></el-table-column>
				<el-table-column prop="limitWeight" label="载重(kg)"></el-table-column>
				<el-table-column prop="maxVolume" label="体积限制(m³)"></el-table-column>
				<el-table-column prop="status" :formatter="judge" label="状态"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button v-if="in_configs(70402)" type="text" size="mini" @click="editVehicle(scope.$index, scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background 
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :current-page="currentPage" 
        :page-sizes="[10, 20, 50, 100]" 
        :page-size="pageSize" 
        layout="total, sizes, prev, pager, next, jumper" 
        :total = "parseInt(total)">
			</el-pagination>
			<!-- 弹窗 -->
			<el-dialog title="车辆详情" :visible.sync="dialogFormVisible" :before-close="handleClose" @close="resetForm('vehicleForm')" width="500px" class="fullwidth-form__dialog">
				<el-form :model="vehicleForm" status-icon :rules="rules" ref="vehicleForm" size="small" label-width="80px">
					<el-form-item label="车辆型号"  prop="model">
						<el-input v-model="vehicleForm.model" auto-complete="off" placeholder="车辆型号"></el-input>
					</el-form-item>
					<el-form-item label="车牌号"  prop="licensePlate">
						<el-input v-model="vehicleForm.licensePlate" auto-complete="off" placeholder="车牌号"></el-input>
					</el-form-item>
					<el-form-item label="车辆类型"  prop="vehicleType">
						<el-input v-model="vehicleForm.vehicleType" auto-complete="off" placeholder="车辆类型"></el-input>
					</el-form-item>
					<el-form-item label="载重限制"  prop="limitWeight">
						<el-input v-model.number="vehicleForm.limitWeight" auto-complete="off" placeholder="单位（kg）"></el-input>
					</el-form-item>
					<el-form-item label="体积限制"  prop="maxVolume">
						<el-input v-model.number="vehicleForm.maxVolume" auto-complete="off" placeholder="单位（m³）"></el-input>
					</el-form-item>
					<el-form-item label="状态" >
						<el-radio v-model="vehicleForm.status" label="1">启用</el-radio>
						<el-radio v-model="vehicleForm.status" label="0">停用</el-radio>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="resetForm('vehicleForm')">取 消</el-button>
					<el-button size="small" type="primary" @click="submitVehicleForm('vehicleForm')">确 定</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
export default {
  data() {
    var licensePlateCheck = (rule, value, callback) => {
      var pattern = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂港澳]{1}$/;
      if(!pattern.test(value.toUpperCase())){
        return callback(new Error('请输入合格的车牌号！'));
      }
      if(value){
        let licensePlate = value.toUpperCase();
				this.$request1({
				  method: 'POST',
          url: '/system/vehicle/check',
          params: {
            id: this.vehicleForm.id,
            licensePlate: licensePlate
          }
				}).then(response => {
					if(response.data.message == "duplicate license plate"){
						callback(new Error('车牌号已存在！'));
					}else{
            callback();
          }
				}).catch(error => {
					console.log(error);
				})
      }
    };
    var limitWeightCheck = (rule, value, callback) => {
      var pattern = /^[0-9]+.?[0-9]*$/;
      if(!pattern.test(value)){
        return callback(new Error('请输入数字值'));
      }else{
        callback();
      }
    };
    var maxVolumeCheck = (rule, value, callback) => {
      var pattern = /^[0-9]+.?[0-9]*$/;
      if(!pattern.test(value)){
        return callback(new Error('请输入数字值'));
      }else{
        callback();
      }
    };
    return {
      conditions: {
        search: ""
      },
      vehicleData: [],
      vehicleForm: {
        id: "",
        model: "",
        licensePlate: "",
        vehicleType: "",
        limitWeight: "",
        maxVolume: "",
        status: "1"
      },
      rules: {
        model: [
          { required: true, message: "请输入车辆型号", trigger: "blur" }
        ],
        licensePlate: [
          { required: true, message: "请输入车牌号", trigger: "blur" },
          {validator: licensePlateCheck, trigger: 'blur'},
        ],
        vehicleType: [
          { required: true, message: "请输入车辆类型", trigger: "blur" }
        ],
        limitWeight: [
          {validator: limitWeightCheck, trigger: 'blur'},
          { required: true, message: "请输入载重限制", trigger: "blur" }
        ],
        maxVolume: [
          {validator: maxVolumeCheck, trigger: 'blur'},
          { required: true, message: "请输入体积限制", trigger: "blur" }
        ]
      },
      currentPage: 1, // 当前是第几页
      pageSize: 10, // 每页显示条目个数
      total: 0, // 总条目数
      dialogFormVisible: false,
    };
  },
  created() {
    setTimeout(() => {
      this._initVehicle(this.conditions.search, this.currentPage, this.pageSize);
      this.loading = false;
    }, 1000);
  },
  computed: {
    //权限
    configs() {
      let conf = JSON.parse(sessionStorage.configs),
        arr = [];
      conf.forEach((d, i) => {
        arr.push(d.name);
      });
      return arr;
    }
  },
  methods: {
    judge(data) {
      return data.status == "1" ? "启用" : "停用";
    },
    // 初始化车辆方法
    _initVehicle(licensePlate, currentPage, pageSize) {
      if(licensePlate === '') {licensePlate = null}
      this.$request1({
        method: "GET",
        url: '/system/vehicle/queryLicensePlate',
        params: {
          licensePlate: licensePlate,
          currentPage: currentPage,
          pageSize: pageSize
        }
      })
        .then(response => {
          if(response.data.success){
            let vehicleList = response.data.data
            if (vehicleList && vehicleList.length > 0) {
              this.vehicleData = vehicleList;
              this.total = response.data.total;
            } else{
              this.vehicleData = [];
            }
          }else{
            this.$message.error(response.data.message)
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //搜索
    searchVehicle() {
      let licensePlate = this.conditions.search.trim().toUpperCase();
      this._initVehicle(licensePlate, this.currentPage, this.pageSize);
    },
    //编辑车辆的方法
    editVehicle(index, row) {
      this.dialogFormVisible = true;
      this.vehicleForm.id = row.id;
      this.vehicleForm.model = row.model;
      this.vehicleForm.licensePlate = row.licensePlate;
      this.vehicleForm.vehicleType = row.vehicleType;
      this.vehicleForm.limitWeight = row.limitWeight;
      this.vehicleForm.maxVolume = row.maxVolume;
      this.vehicleForm.status = row.status.toString();
    },
    // 添加车辆的方法
    submitVehicleForm(formName) {
      this.$refs[formName].validate((valid) => {
        if(valid){
          this.$request1({
            method: 'POST',
            url: '/system/vehicle',
            data: this.vehicleForm
          })
          .then(response => {
            if(response.data.success){
              this.$message.success('成功！')
              this._initVehicle(this.conditions.search, this.currentPage, this.pageSize);
              this.$refs[formName].resetFields();	
              this.handleClose();
              this.dialogFormVisible = false;
            } else{
              this.$message.error(response.data.message)
            }
          })
          .catch(error => {
            console.log(error);
          });
        }else{
					return false;
        }
      })
    },
    //删除车辆的方法
    deleteVehicle(index, rows) {
      this.$confirm("您确定要删除这条车辆信息吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(() => {
        let id = rows[index].id;
        this.$request1({
          method: 'GET',
          url: '/system/vehicle/delete/' + id + '',
        })
          .then(response => {
            rows.splice(index, 1);
            this._initVehicle(this.conditions.search, this.currentPage, this.pageSize);
            this.$message({
              message: "删除成功",
              type: "success",
              center: true,
              duration: 1500
            });
          })
          .catch(error => {
            console.log(error);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 关闭弹窗时的方法
    handleClose() {
      this.dialogFormVisible = false;
      this.vehicleForm.id = "";
      this.vehicleForm.model = "";
      this.vehicleForm.licensePlate = "";
      this.vehicleForm.vehicleType = "";
      this.vehicleForm.limitWeight = "";
      this.vehicleForm.maxVolume = "";
      this.vehicleForm.status = "1";
    },
    resetForm(formName){
			this.$refs[formName].clearValidate();
			this.handleClose();
		},
    //每页的条数
    handleSizeChange(val) { // pageSize 改变时会触发，参数： 每页条数size
      this.pageSize = val;
      this._initVehicle(this.conditions.search, this.currentPage, val);
    },
    // 当前是第几页
    handleCurrentChange(val) { // currentPage 改变时会触发，参数：当前页currentPage
      this._initVehicle(this.conditions.search, val, this.pageSize);
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/vehicle.vue